import firebase from "../../../config/firebase";
// import * as admin from 'firebase-admin';

// import sendgrid from "sendgrid";
import { uploadImage } from "../Company/imageHandler";
import {
  postJobSuccess,
  postJobError,
  postJobClear,
  sendEmail,
  newsLetter
} from "../../actions/jobsActions";
import { CATEGORIES } from "../../../Utils";
// const  client = sendgrid("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")
// admin.initializeApp({
//   credential: admin.credential.applicationDefault(),
//   databaseURL: 'https://heyremote-6db3c.firebaseio.com'
// });
// const functions = require('firebase-functions')
// admin.initializeApp()
const db = firebase.firestore();
const jobObject = (jobObj, companyObj) => {
  const date = new Date();
  return {
    title: jobObj.jobTitle,
    category: jobObj.jobCategory,
    type: jobObj.jobType,
    description: jobObj.jobDescription,
    salary: jobObj.jobSalary,
    howToApply: jobObj.howToApply,
    location: jobObj.jobRegionalRestriction,
    // tags: ,
    // companyEmail: jobObj.companyEmail,
    company: companyObj,
    status: jobObj.jobStatus || "active", //"pending",
    isFeature: false,
    postedAt: firebase.firestore.FieldValue.serverTimestamp(),
    expiresAt: date.setDate(date.getDate() + 30),
    postType: jobObj.postType || "internal",
    postedBy: jobObj.postedBy || undefined
  };
};
const editJobObject = jobObj => {
  return {
    title: jobObj.jobTitle,
    category: jobObj.jobCategory,
    type: jobObj.jobType,
    description: jobObj.jobDescription,
    salary: jobObj.jobSalary,
    howToApply: jobObj.howToApply,
    location: jobObj.jobRegionalRestriction,
    status: jobObj.jobStatus || "active" //"pending",
  };
};

const companyObject = obj => {
  return {
    name: obj.companyName,
    email: obj.companyEmail,
    statement: obj.companyStatement,
    logo: obj.companyLogo,
    websiteURL: obj.companyWebsiteURL,
    confirmationEmail: obj.companyConfirmationEmail,
    description: obj.companyDescription,
    companyHQ: obj.companyHQ
  };
};

const compareObjects = (obj1, obj2) => {
  for (let key in obj1) {
    if (obj1[key] != obj2[key]) {
      console.log({ obj1, obj2 });
      return false;
    }
  }
  return true;
};

export const post_new_job = obj => async (dispatch, getState) => {
  console.log(getState());
  const { currentCompany } = getState().companyReducer;

  // Initialize Post Job Reducer.
  dispatch(postJobClear());

  // If Company Is Not Previously Registered || If any field changes
  if (!currentCompany.name) {
    try {
      let logoURL = await uploadImage(obj.companyLogo, obj.companyEmail);
      obj.companyLogo = logoURL;
      // console.log(logoURL);
      let newCompanyRef = db.collection("companies").doc();
      db.collection("companies")
        .doc(newCompanyRef.id)
        .set({
          ...companyObject(obj),
          id: newCompanyRef.id,
          jobsPosted: 1,
          hiring: true
        })
        .then(async companyRef => {
          console.log(companyRef);
          let newJobRef = db.collection("jobs").doc();
          return await db
            .collection("jobs")
            .doc(newJobRef.id)
            .set({
              ...jobObject(obj, {
                ...companyObject(obj),
                id: newCompanyRef.id
              }),
              id: newJobRef.id
            });
        })
        .then(jobRef => {
          console.log(jobRef);
          dispatch(postJobSuccess());
        })
        .catch(error => {
          console.log(error);
          dispatch(postJobError(error));
        });
    } catch (error) {
      console.log(error);
      dispatch(postJobError(error));
    }
  }
  // The company exists but changed the data
  else if (!compareObjects(currentCompany, companyObject(obj))) {
    console.log("else if");
    try {
      if (currentCompany.logo !== obj.companyLogo) {
        let logoURL = await uploadImage(obj.companyLogo, obj.companyEmail);
        obj.companyLogo = logoURL;
        // console.log(logoURL);
      }
      let newCompanyRef = db.collection("companies").doc(currentCompany.id);
      console.log(newCompanyRef);
      db.collection("companies")
        .doc(newCompanyRef.id)
        .update({
          ...companyObject(obj),
          id: newCompanyRef.id,
          jobsPosted: firebase.firestore.FieldValue.increment(1),
          hiring: true
        })
        .then(async companyRef => {
          console.log(companyRef);
          let newJobRef = db.collection("jobs").doc();
          return await db
            .collection("jobs")
            .doc(newJobRef.id)
            .set({
              ...jobObject(obj, {
                ...companyObject(obj),
                id: newCompanyRef.id
              }),
              id: newJobRef.id
            });
        })
        .then(jobRef => {
          console.log(jobRef);
          dispatch(postJobSuccess());
        })
        .catch(error => {
          console.log(error);
          dispatch(postJobError(error));
        });
    } catch (error) {
      console.log(error);
      dispatch(postJobError(error));
    }
  }

  // Previous
  // if (
  //   !currentCompany.name ||
  //   !compareObjects(currentCompany, companyObject(obj)) // insert ! before compareObjects()
  // ) {
  //   if (currentCompany.logo !== obj.companyLogo) {
  //     logoURL = await uploadImage(obj.companyLogo, obj.companyEmail);
  //     obj.companyLogo = logoURL;
  //     console.log(logoURL);
  //   }
  //   let newCompanyRef;

  //   // If the company exists previously than it overrides else it creates new Reference
  //   if (currentCompany.id) {
  //     newCompanyRef = db.collection("companies").doc(currentCompany.id);
  //   } else {
  //     newCompanyRef = db.collection("companies").doc();
  //   }
  //   console.log(newCompanyRef);
  //   db.collection("companies")
  //     .doc(newCompanyRef.id)
  //     .set({
  //       ...companyObject(obj),
  //       id: newCompanyRef.id
  //     })
  //     .then(async companyRef => {
  //       console.log(companyRef);
  //       let newJobRef = db.collection("jobs").doc();
  //       return await db
  //         .collection("jobs")
  //         .doc(newJobRef.id)
  //         .set({
  //           ...jobObject(obj, {
  //             ...companyObject(obj),
  //             id: newCompanyRef.id
  //           }),
  //           id: newJobRef.id
  //         });
  //     })
  //     .then(jobRef => {
  //       console.log(jobRef);
  //       newCompanyRef
  //         .update({
  //           jobsPosted: firebase.firestore.FieldValue.increment(10),
  //           hiring: true
  //         })
  //         .then(res => console.log(res));
  //       dispatch(postJobSuccess());
  //     })
  //     .catch(error => {
  //       console.log(error);
  //       dispatch(postJobError(error));
  //     });
  // }
  else {
    console.log("already exists");
    db.collection("jobs")
      .add(jobObject(obj, { ...companyObject(obj), id: currentCompany.id }))
      .then(jobRef => {
        db.collection("companies")
          .doc(currentCompany.id)
          .update({
            jobsPosted: firebase.firestore.FieldValue.increment(1),
            hiring: true
          })
          .then(res => console.log(res));
        dispatch(postJobSuccess());
      })
      .catch(error => {
        console.log(error);
        dispatch(postJobError(error));
      });
  }
};

export const update_job = obj => async (dispatch, getState) => {
  // console.log(getState());
  // const { currentCompany } = getState().companyReducer;

  // Initialize Post Job Reducer.
  dispatch(postJobClear());

  // If Company Is Not Previously Registered || If any field changes
  // if (!currentCompany.name) {
  //   try {
  //     let logoURL = await uploadImage(obj.companyLogo, obj.companyEmail);
  //     obj.companyLogo = logoURL;
  //     // console.log(logoURL);
  //     let newCompanyRef = db.collection("companies").doc();
  //     db.collection("companies")
  //       .doc(newCompanyRef.id)
  //       .set({
  //         ...companyObject(obj),
  //         id: newCompanyRef.id,
  //         jobsPosted: 1,
  //         hiring: true
  //       })
  //       .then(async companyRef => {
  //         console.log(companyRef);
  //         let newJobRef = db.collection("jobs").doc();
  //         return await db
  //           .collection("jobs")
  //           .doc(newJobRef.id)
  //           .set({
  //             ...jobObject(obj, {
  //               ...companyObject(obj),
  //               id: newCompanyRef.id
  //             }),
  //             id: newJobRef.id
  //           });
  //       })
  //       .then(jobRef => {
  //         console.log(jobRef);
  //         dispatch(postJobSuccess());
  //       })
  //       .catch(error => {
  //         console.log(error);
  //         dispatch(postJobError(error));
  //       });
  //   } catch (error) {
  //     console.log(error);
  //     dispatch(postJobError(error));
  //   }
  // }
  // The company exists but changed the data
  // else
  // if (!compareObjects(currentCompany, companyObject(obj))) {
  // console.log("else if");
  // -----Aftre "try" --------//
  // if (currentCompany.logo !== obj.companyLogo) {
  //   let logoURL = await uploadImage(obj.companyLogo, obj.companyEmail);
  //   obj.companyLogo = logoURL;
  //   // console.log(logoURL);
  // }
  // let newCompanyRef = db.collection("companies").doc(currentCompany.id);
  // console.log(newCompanyRef);
  // db.collection("companies")
  //   .doc(newCompanyRef.id)
  //   .update({
  //     ...companyObject(obj),
  //     id: newCompanyRef.id,
  //     jobsPosted: firebase.firestore.FieldValue.increment(1),
  //     hiring: true
  //   })
  // .then(async companyRef => {
  //   console.log(companyRef);
  try {
    let newJobRef = db.collection("jobs").doc(obj.id);
    return await db
      .collection("jobs")
      .doc(newJobRef.id)
      .update({
        ...editJobObject(obj)
        // });
      })
      .then(jobRef => {
        console.log(jobRef);
        dispatch(postJobSuccess());
      })
      .catch(error => {
        console.log(error);
        dispatch(postJobError(error));
      });
  } catch (error) {
    console.log(error);
    dispatch(postJobError(error));
  }
};
// else {
//   console.log("already exists");
//   db.collection("jobs")
//     .add(jobObject(obj, companyObject(obj)))
//     .then(jobRef => {
//       db.collection("companies")
//         .doc(currentCompany.id)
//         .update({
//           jobsPosted: firebase.firestore.FieldValue.increment(1),
//           hiring: true
//         })
//         .then(res => console.log(res));
//       dispatch(postJobSuccess());
//     })
//     .catch(error => {
//       console.log(error);
//       dispatch(postJobError(error));
//     });
// }
// };

export const job_activated = (job, newStatus) => async dispatch => {
  dispatch(sendEmail(undefined));
  fetch(
    "https://us-central1-heyremote-6db3c.cloudfunctions.net/emailVerification",
    {
      method: "POST",
      body: JSON.stringify({
        name: "arslan",
        email: job?.selectedJob?.company?.confirmationEmail,
        jobId: job?.selectedJob?.id,
        jobTitle: job?.selectedJob?.title,
        job: job?.selectedJob,
        status: job?.newStatus
      }),
      "content-type": "application/json"
    }
  )
    .then(res => res.text())
    .then(res => {
      console.log(res);
      dispatch(sendEmail(res));
    })
    .catch(err => {
      console.log(err.message);
      dispatch(sendEmail(err.message));
    });
};

export const sendNewsLetter = data => dispatch => {
  console.log(data, "yes");
  fetch(
    "https://us-central1-heyremote-6db3c.cloudfunctions.net/sendNewsLetter",
    {
      method: "POST",
      body: JSON.stringify({ jobs: data.jobs, subscribers: data.subscribers }),
      "content-type": "application/json"
    }
  )
    .then(res => res.text())
    .then(res => {
      console.log(res);
      if (res) {
        console.log(res);
        let jobs = {
          jobs: data?.jobs,
          subscribers: data?.subscribers,
          timeStamp: firebase.firestore.FieldValue.serverTimestamp()
        };
        db.collection("newsLetters")
          .add({ data: jobs })
          .then(news => {
            console.log(news);
            dispatch(newsLetter(true));
          })
          .catch(err => console.log(err));
      }
    })
    .catch(err => {
      console.log(err.message);
      dispatch(newsLetter(err.message));
    })
    .then(res => res.text())
    .then(res => {
      console.log(res);
      if (res) {
        console.log(res);
        let jobs = {
          jobs: data?.jobs,
          subscribers: data?.subscribers,
          timeStamp: firebase.firestore.FieldValue.serverTimestamp()
        };
        db.collection("newsLetters")
          .add({ data: jobs })
          .then(news => {
            console.log(news);
            dispatch(newsLetter(true));
          })
          .catch(err => console.log(err));
      }
    })
    .catch(err => {
      console.log(err.message);
      dispatch(newsLetter(err.message));
    });
};
